import { useEffect } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { getCurrentAttendee } from '../../helpers/getters';
import CustomPropTypes from '../../helpers/CustomPropTypes';
import { parseFieldsByInternalId } from '../../helpers/customFields';
import callApi, { fetchConfig } from '../../actions/callApi';
import { INTERNAL_IDS } from '../../helpers/constants';

const Component = ({ entities, attendeeTypeCustomFields, callApi: dispatchCallApi }) => {
  const currentAttendee = getCurrentAttendee(entities, { parseCustomFields: true });
  const fieldsId = parseFieldsByInternalId(currentAttendee?.fields, attendeeTypeCustomFields);
  const termsFieldId = fieldsId[INTERNAL_IDS.terms];
  const acceptedTerms = !!currentAttendee && currentAttendee.fields[termsFieldId];

  useEffect(() => {
    const data = new FormData();
    data.append(`attendee[custom_fields][${termsFieldId}]`, true);
    if (!acceptedTerms) dispatchCallApi('updateCurrentAttendee', { id: currentAttendee.id, data })
      .then(({ type, error: errors }) => {
        const [, , updateFailure] = fetchConfig.updateCurrentAttendee.types;
        if (type === updateFailure) console.error(
          Array.isArray(errors) ? errors.join(', ') : errors
        );
      });
  }, []);
  return null;
};

Component.propTypes = {
  entities: CustomPropTypes.entities.isRequired,
  attendeeTypeCustomFields: PropTypes.objectOf(
    CustomPropTypes.attendeeTypeCustomField
  ),
  callApi: PropTypes.func.isRequired,
};

Component.defaultProps = {
  attendeeTypeCustomFields: {},
};

const mapStateToProps = ({
  entities,
  entities: {
    attendeeTypeCustomFields,
  },
}) => ({
  entities,
  attendeeTypeCustomFields,
});

const mapDispatchToProps = { callApi };

export default connect(mapStateToProps, mapDispatchToProps)(Component);
